import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalService,
} from '@azure/msal-angular';
import { AuthHttpInterceptor } from '@nimbus-library/features/authentication/services/auth-http.interceptor';
import {
  IAuthenticationStorage,
  TOKEN_STORAGE,
  USER_INFO_STORAGE,
} from '@nimbus-library/features/authentication/services/i-authentication-storage';
import { CookieAuthenticationStorageService } from '@nimbus-library/features/authentication/services/cookie-authentication-storage';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { MsalAuthenticationService } from '@nimbus-library/features/authentication/services/msal-authentication.service';
import { TeamsAuthenticationService } from '@nimbus-library/features/authentication/services/teams-authentication.service';
import { HybridAuthenticationService } from '@nimbus-library/features/authentication/services/hybrid-authentication.service';
import {
  MSAL_LOGGING_ENABLED,
  MSALGuardConfigFactory,
  MSALInstanceFactory,
  MSALInterceptorConfigFactory,
  msalLoggingEnabledFactory,
} from '@nimbus-library/features/authentication/factories/msal.factories';
import { AppMode, appModeProvider } from '@nimbus-portal/features/app-mode/app-mode';
import { WallboardAuthenticationService } from '@nimbus-portal/features/wallboard/services/infrastructure/wallboard-authentication.service';
import { WallboardAuthenticationStorageService } from '@nimbus-portal/features/wallboard/services/infrastructure/wallboard-authentication-storage.service';

@NgModule({
  imports: [],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    {
      provide: TOKEN_STORAGE,
      useValue: 'Nimbus.Auth',
    },
    { provide: USER_INFO_STORAGE, useValue: 'Nimbus.User' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
    HybridAuthenticationService,
    CookieAuthenticationStorageService,
    appModeProvider(IAuthenticationService, {
      [AppMode.Default]: HybridAuthenticationService,
      [AppMode.Wallboard]: WallboardAuthenticationService,
    }),
    appModeProvider(IAuthenticationStorage, {
      [AppMode.Default]: CookieAuthenticationStorageService,
      [AppMode.Wallboard]: WallboardAuthenticationStorageService,
    }),
    { provide: MSAL_LOGGING_ENABLED, useFactory: msalLoggingEnabledFactory },
    TeamsAuthenticationService,
    MsalAuthenticationService,
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
})
export class NimbusAuthneticationModule {}
